// extracted by mini-css-extract-plugin
export default {"content":"UploadListPage_content__E9iWq","breadcrumbContainer":"UploadListPage_breadcrumbContainer__3PyAq"};